import $ from 'jquery';

$(function () {
  const $paidEventToggle = $('#paid-event-toggle');
  const $freeEventToggle = $('#free-event-toggle');
  const $paidEventForm = $('#paid-event-form');
  const $freeEventForm = $('#free-event-form');

  if ($('.add-event__choices').length) {
    // Attach handler for checkboxes
    $('.add-event__choices input[type="checkbox"]')
      .toArray()
      .forEach((input) => {
        $(input).on('click', (event) => {
          handleCheckboxInput(event);
        });
      });

    // Allow one checkbox to be active at a time
    $('input[type="checkbox"]').on('change', function (event) {
      $('input[type="checkbox"]').not(this).prop('checked', false);
      handleCheckboxInput(event);
    });

    const handleCheckboxInput = (event) => {
      // Keep one checkbox active at all times
      if (
        $(event.target).attr('id') === 'free-event-toggle' &&
        $freeEventToggle.prop('checked') === false
      ) {
        $paidEventToggle.prop('checked', true);
      } else if (
        $(event.target).attr('id') === 'paid-event-toggle' &&
        $paidEventToggle.prop('checked') === false
      ) {
        $freeEventToggle.prop('checked', true);
      }

      if ($paidEventToggle.prop('checked') === true) {
        $freeEventForm.hide();
        $paidEventForm.show();
      } else {
        $paidEventForm.hide();
        $freeEventForm.show();
      }
    };

    // Set initial form
    if ($freeEventToggle.prop('checked') === true) {
      $paidEventForm.hide();
      $freeEventForm.show();
    }

    // Redirect to thank you page on submission
    document.addEventListener(
      'wpcf7mailsent',
      (event) => {
        console.log(event.detail);
        return;
        window.location = `${window.location.protocol}//${window.location.hostname}/thank-you-event-submission`;
      },
      false
    );
  }
});
